<app-custom-navigation-ui [node]="node$ | async" [ngClass]="styleClass$ | async">
</app-custom-navigation-ui>